import React from "react";

function Refund() {
    return (
        <div style={styles.container}>
            <h1>Refund Policy</h1>

            <p>
                At Scan4Help, we aim to provide a smooth and reliable service.
            </p>

            <h3>Refund Eligibility</h3>
            <p>
                Refunds are only applicable in the following cases:
            </p>
            <ul>
                <li>Duplicate payment</li>
                <li>Failed transaction where amount was deducted</li>
            </ul>

            <h3>Non-Refundable Cases</h3>
            <p>
                Once the QR code is generated and services are delivered successfully,
                refunds are not applicable.
            </p>

            <h3>Processing Time</h3>
            <p>
                Eligible refunds will be processed within 5-7 business days.
            </p>

            <h3>Contact</h3>
            <p>
                For refund requests, contact us at support@scan4help.app
            </p>

            <p style={styles.footer}>Last updated: {new Date().toLocaleDateString()}</p>
        </div>
    );
}

const styles = {
    container: {
        maxWidth: "800px",
        margin: "auto",
        padding: "20px",
        lineHeight: "1.6",
        fontFamily: "Arial"
    },
    footer: {
        marginTop: "20px",
        fontSize: "12px",
        color: "gray"
    }
};

export default Refund;